import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M12 2.5c5.247 0 9.5 4.253 9.5 9.5s-4.253 9.5-9.5 9.5A9.5 9.5 0 0 1 2.5 12 9.5 9.5 0 0 1 12 2.5z",
    opacity: ".3"
  }), /*#__PURE__*/_jsx("path", {
    d: "m14.355 8.905-2.456 2.456-2.456-2.456a.4.4 0 1 0-.567.567l2.456 2.456-2.456 2.456a.4.4 0 1 0 .567.567l2.456-2.456 2.456 2.456a.4.4 0 1 0 .567-.567l-2.456-2.456 2.456-2.456a.4.4 0 1 0-.567-.567z"
  })]
}), 'CrossDelete');